import { render, staticRenderFns } from "./ExpensesbyAccount.vue?vue&type=template&id=1afc92df&scoped=true"
import script from "./ExpensesbyAccount.vue?vue&type=script&lang=js"
export * from "./ExpensesbyAccount.vue?vue&type=script&lang=js"
import style0 from "./ExpensesbyAccount.vue?vue&type=style&index=0&id=1afc92df&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc92df",
  null
  
)

export default component.exports